import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Router} from '@angular/router';
import { LoginService } from 'app/services/login/login.service';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate,CanActivateChild {

  
  IdRolUser : any ;
  clickGuard :any;
  
  constructor(private router:Router,private loginService: LoginService){

  }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {


    this.clickGuard = this.loginService.clickGuard;
    this.IdRolUser = JSON.parse(sessionStorage.getItem("UserRol"));
    


      if(this.clickGuard){
         this.loginService.clickGuard = false;
         return true;
      }else if(!this.clickGuard){
        this.router.navigate(['/login']);
        return false;
      }

      else if (this.IdRolUser == null || this.IdRolUser == undefined ) {
          this.router.navigate(['/login']);
          return false;
      }  
      this.router.navigate(['/error404']);
       return false;
    }
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  boolean {
      return this.canActivate(route, state);
 }
  }
  

